import Vue from 'vue'
import App from './App.vue'
import router from './router'
import 'lib-flexible/flexible'
import './assets/css/index.css'
import store from './store'
import moment from 'moment'

Vue.prototype.moment = moment
Vue.config.productionTip = false
Vue.prototype.store = store

import {
  Col,
  Row,
  Swipe,
  SwipeItem,
  Tab,
  Tabs,
  PullRefresh,
  Button,
  Field,
  Form,
  Toast,
  List,
  DatetimePicker,
  Popup,
  Cell,
  CellGroup,
  Picker,
  Dialog,
  Icon,
  Circle,
  RadioGroup,
  Radio,
  Uploader,
  Progress,
  Checkbox,
  Empty,
  NavBar,
  Loading
} from 'vant'

Vue.use(Col)
Vue.use(Row)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(PullRefresh)
Vue.use(Button)
Vue.use(Field)
Vue.use(Form)
Vue.use(Toast)
Vue.use(List)
Vue.use(DatetimePicker)
Vue.use(Popup)
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(Picker)
Vue.use(Dialog)
Vue.use(Icon)
Vue.use(Circle)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Uploader)
Vue.use(Progress)
Vue.use(Checkbox)
Vue.use(Empty)
Vue.use(NavBar)
Vue.use(Loading)

// import VConsole from 'vconsole'
// if (process.env.VUE_APP_MODE !== 'production') {
//   const vConsole = new VConsole()
//   Vue.use(vConsole)
// }

Vue.filter('formatDate', function(value) {
  return moment(value).format('YYYY-MM-DD')
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }

  if (to.meta.navIndex) {
    store.commit('getNavIndex', to.meta.navIndex)
  }

  next()
})

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
